const StudentMessagePage = () => {
  return <div>StudentMessagePage</div>;
};

export default StudentMessagePage;
